"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var CheckoutExtraHeader = function CheckoutExtraHeader(props) {
  var label = props.label,
    image = props.image;
  var hasLabel = Boolean(label);
  return /*#__PURE__*/_react["default"].createElement(StyledHeaderContainer, null, image, hasLabel ? /*#__PURE__*/_react["default"].createElement(StyledHeaderLabel, null, label) : null);
};
var StyledHeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraHeader__StyledHeaderContainer",
  componentId: "sc-1g5hpgm-0"
})(["width:100%;height:73px;overflow:hidden;position:relative;background:linear-gradient( to right,rgba(255,242,217,1),rgba(255,230,224,1) );"]);
var StyledHeaderLabel = _styledComponents["default"].div.withConfig({
  displayName: "CheckoutExtraHeader__StyledHeaderLabel",
  componentId: "sc-1g5hpgm-1"
})(["top:0;right:0;position:absolute;margin:16px;font-family:Backpack;font-style:normal;font-weight:normal;font-size:12px;line-height:13px;letter-spacing:0.1em;text-transform:uppercase;color:#866b60;"]);
var _default = exports["default"] = CheckoutExtraHeader;